import masters from '@/store/modules/masterModules/masterModule.js'
import systemAdminDefine from '@/store/systemAdminModules/systemAdminDefineModules/systemAdminDefineModule.js'
import Vue from 'vue'
import Router from 'vue-router'

// 管理パネル（企業）
import adminAccounts from '@/components/adminAccounts/adminAccounts.vue'
import assessmentInfos from '@/components/assessmentInfos/assessmentInfos.vue'
import auditLoggings from '@/components/auditLoggings/auditLoggings.vue'
import beacons from '@/components/beacons/beacons.vue'
import belongs from '@/components/belongs/belongs.vue'
import careRings from '@/components/careRings.vue'
import careRingsLogin from '@/components/careRingsLogin/careRingsLogin.vue'
import careworkers from '@/components/careworkers/careworkers.vue'
import dashboard from '@/components/dashboard/dashboard.vue'
import devices from '@/components/devices/devices.vue'
import loginUsers from '@/components/loginUsers/loginUsers.vue'
import notifications from '@/components/notifications/notifications.vue'
import assigns from '@/components/assigns/assigns.vue'
import places from '@/components/places/places.vue'
import reserve from '@/components/reserve/reserve.vue'

import adminAccountDetail from '@/components/adminAccounts/adminAccountDetail.vue'
import assessmentInfoDetail from '@/components/assessmentInfos/assessmentInfoDetail.vue'
import auditLoggingDetail from '@/components/auditLoggings/auditLoggingDetail.vue'
import beaconDetail from '@/components/beacons/beaconDetail.vue'
import belongDetail from '@/components/belongs/belongDetail.vue'
import careworkerDetail from '@/components/careworkers/careworkerDetail.vue'
import deviceDetail from '@/components/devices/deviceDetail.vue'
import loginUserDetail from '@/components/loginUsers/loginUserDetail.vue'
import placeDetail from '@/components/places/placeDetail.vue'
import assignDetail from '@/components/assigns/assignDetail.vue'
import reserveDetail from '@/components/reserve/reserveDetail.vue'

import adminAccountEdit from '@/components/adminAccounts/adminAccountEdit.vue'
import auditLoggingEdit from '@/components/auditLoggings/auditLoggingEdit.vue'
import beaconEdit from '@/components/beacons/beaconEdit.vue'
import belongEdit from '@/components/belongs/belongEdit.vue'
import careworkerEdit from '@/components/careworkers/careworkerEdit.vue'
import deviceEdit from '@/components/devices/deviceEdit.vue'
import placeEdit from '@/components/places/placeEdit.vue'
import assignEdit from '@/components/assigns/assignEdit.vue'
import reserveEdit from '@/components/reserve/reserveEdit.vue'

import adminAccountAdd from '@/components/adminAccounts/adminAccountAdd.vue'
import beaconAdd from '@/components/beacons/beaconAdd.vue'
import belongAdd from '@/components/belongs/belongAdd.vue'
import careworkerAdd from '@/components/careworkers/careworkerAdd.vue'
import deviceAdd from '@/components/devices/deviceAdd.vue'
import placeAdd from '@/components/places/placeAdd.vue'
import assignAdd from '@/components/assigns/assignAdd.vue'
import reserveAdd from '@/components/reserve/reserveAdd.vue'

// 管理パネル（マスター）
import careRingsMasterLogin from '@/components/masterPanel/masterLogin/careRingsMasterLogin.vue'
import careRingsMasterPage from '@/components/masterPanel/masterView/careRingsMaster.vue'
import corporationCommon from '@/components/masterPanel/masterView/corporationCommonView/corporationCommon.vue'
import corporationAdd from '@/components/masterPanel/masterView/CorporationView/corporationAdd.vue'
import corporationDetail from '@/components/masterPanel/masterView/CorporationView/corporationDetail.vue'
import corporationEdit from '@/components/masterPanel/masterView/CorporationView/corporationEdit.vue'
import corporationLogExport from '@/components/masterPanel/masterView/CorporationView/corporationLogExport.vue'
import corporationMaintenance from '@/components/masterPanel/masterView/CorporationView/corporationMaintenance.vue'
import corporationNotifications from '@/components/masterPanel/masterView/CorporationView/corporationNotifications.vue'
import corporationUsageExport from '@/components/masterPanel/masterView/CorporationView/corporationUsageExport.vue'
import corporations from '@/components/masterPanel/masterView/CorporationView/corporations.vue'
import maintenance from '@/components/masterPanel/masterView/maintenance/maintenance.vue'
import maintenanceDetail from '@/components/masterPanel/masterView/maintenance/maintenanceDetail.vue'
import maintenanceAdd from '@/components/masterPanel/masterView/maintenance/maintenanceAdd.vue'
import maintenanceAddConfirm from '@/components/masterPanel/masterView/maintenance/maintenanceAddConfirm.vue'
import maintenanceEdit from '@/components/masterPanel/masterView/maintenance/maintenanceEdit.vue'
import maintenanceEditConfirm from '@/components/masterPanel/masterView/maintenance/maintenanceEditConfirm.vue'
import notification from '@/components/masterPanel/masterView/notification/notification.vue'
import notificationAdd from '@/components/masterPanel/masterView/notification/notificationAdd.vue'
import notificationAddConfirm from '@/components/masterPanel/masterView/notification/notificationAddConfirm.vue'
import notificationDetail from '@/components/masterPanel/masterView/notification/notificationDetail.vue'
import notificationEdit from '@/components/masterPanel/masterView/notification/notificationEdit.vue'
import notificationEditConfirm from '@/components/masterPanel/masterView/notification/notificationEditConfirm.vue'
import mailHistory from '@/components/masterPanel/masterView/mailHistory/mailHistory.vue'
import mailHistoryDetail from '@/components/masterPanel/masterView/mailHistory/mailHistoryDetail.vue'
import forcedUpdate from '@/components/masterPanel/masterView/forcedUpdate/forcedUpdate.vue'

Vue.use(Router)

const router = new Router({
  // URLに#を含まないようにするHTML5のhistory.pushState API
  mode: 'history',
  routes: [
    {
      path: '/Pages',
      name: 'careRingsLogin',
      component: careRingsLogin
    },
    {
      path: '/careRings',
      name: 'careRings',
      component: careRings,
      meta: {requiresAuth: true},
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          component: dashboard
        },
        {
          path: '/devices',
          name: 'devices',
          component: devices,
          children: [
            {path: 'detail', name: 'deviceDetail', component: deviceDetail},
            {path: 'edit', name: 'deviceEdit', component: deviceEdit},
            {path: 'add', name: 'deviceAdd', component: deviceAdd}
          ]
        },
        {
          path: '/places',
          name: 'places',
          component: places,
          children: [
            {path: 'detail', name: 'placeDetail', component: placeDetail},
            {path: 'edit', name: 'placeEdit', component: placeEdit},
            {path: 'add', name: 'placeAdd', component: placeAdd}
          ]
        },
        {
          path: '/belongs',
          name: 'belongs',
          component: belongs,
          children: [
            {path: 'detail', name: 'belongDetail', component: belongDetail},
            {path: 'edit', name: 'belongEdit', component: belongEdit},
            {path: 'add', name: 'belongAdd', component: belongAdd}
          ]
        },
        {
          path: '/careworkers',
          name: 'careworkers',
          component: careworkers,
          children: [
            {
              path: 'detail',
              name: 'careworkerDetail',
              component: careworkerDetail
            },
            {path: 'edit', name: 'careworkerEdit', component: careworkerEdit},
            {path: 'add', name: 'careworkerAdd', component: careworkerAdd}
          ]
        },
        {
          path: '/assessmentInfos',
          name: 'assessmentInfos',
          component: assessmentInfos,
          children: [
            {
              path: 'detail',
              name: 'assessmentInfoDetail',
              component: assessmentInfoDetail
            }
          ]
        },
        {
          path: '/adminAccounts',
          name: 'adminAccounts',
          component: adminAccounts,
          children: [
            {
              path: 'detail',
              name: 'adminAccountDetail',
              component: adminAccountDetail
            },
            {
              path: 'edit',
              name: 'adminAccountEdit',
              component: adminAccountEdit
            },
            {
              path: 'add',
              name: 'adminAccountAdd',
              component: adminAccountAdd
            }
          ]
        },
        {
          path: '/auditLoggings',
          name: 'auditLoggings',
          component: auditLoggings,
          children: [
            {
              path: 'detail',
              name: 'auditLoggingDetail',
              component: auditLoggingDetail
            },
            {
              path: 'edit',
              name: 'auditLoggingEdit',
              component: auditLoggingEdit
            }
          ]
        },
        {
          path: '/beacons',
          name: 'beacons',
          component: beacons,
          children: [
            {path: 'add', name: 'beaconAdd', component: beaconAdd},
            {path: 'detail', name: 'beaconDetail', component: beaconDetail},
            {path: 'edit', name: 'beaconEdit', component: beaconEdit}
          ]
        },
        {
          path: '/loginUsers',
          name: 'loginUsers',
          component: loginUsers,
          children: [
            {
              path: 'detail',
              name: 'loginUserDetail',
              component: loginUserDetail
            }
          ]
        },
        {
          path: '/notifications',
          name: 'notifications',
          component: notifications
        },
        {
          path: '/assigns',
          name: 'assigns',
          component: assigns,
          children: [
            {
              path: 'detail',
              name: 'assignDetail',
              component: assignDetail
            },
            {
              path: 'edit',
              name: 'assignEdit',
              component: assignEdit
            },
            {
              path: 'add',
              name: 'assignAdd',
              component: assignAdd
            }
          ]
        },
        {
          path: '/reserve',
          name: 'reserve',
          component: reserve,
          children: [
            {
              path: 'detail',
              name: 'reserveDetail',
              component: reserveDetail
            },
            {
              path: 'edit',
              name: 'reserveEdit',
              component: reserveEdit
            },
            {
              path: 'add',
              name: 'reserveAdd',
              component: reserveAdd
            }
          ]
        }
      ]
    },
    {
      path: '/Master/Pages',
      name: 'careRingsMasterLogin',
      component: careRingsMasterLogin
    },
    {
      path: '/Master/careRings',
      name: 'careRingsMasterPage',
      component: careRingsMasterPage,
      meta: {requiresMasterAuth: true},
      children: [
        {
          path: '/Master/corporations',
          name: 'corporations',
          component: corporations
        },
        {
          path: '/Master/corporations/detail',
          name: 'corporationDetail',
          component: corporationDetail
        },
        {
          path: '/Master/corporations/edit',
          name: 'corporationEdit',
          component: corporationEdit
        },
        {
          path: '/Master/corporations/add',
          name: 'corporationAdd',
          component: corporationAdd
        },
        {
          path: '/Master/corporations/logs',
          name: 'corporationLogExport',
          component: corporationLogExport
        },
        {
          path: '/Master/corporations/notifications',
          name: 'corporationNotifications',
          component: corporationNotifications
        },
        {
          path: '/Master/corporations/maintenance',
          name: 'corporationMaintenance',
          component: corporationMaintenance
        },
        {
          path: '/Master/corporations/usage',
          name: 'corporationUsageExport',
          component: corporationUsageExport
        },
        {
          path: '/Master/common',
          name: 'common',
          component: corporationCommon
        },
        {
          path: '/Master/mailHistory',
          name: 'mailHistory',
          component: mailHistory
        },
        {
          path: '/Master/mailHistory/detail',
          name: 'mailHistoryDetail',
          component: mailHistoryDetail
        },
        {
          path: '/Master/notification',
          name: 'notification',
          component: notification
        },
        {
          path: '/Master/notification/detail',
          name: 'notificationDetail',
          component: notificationDetail
        },
        {
          path: '/Master/notification/add',
          name: 'notificationAdd',
          component: notificationAdd
        },
        {
          path: '/Master/notification/addConfirm',
          name: 'notificationAddConfirm',
          component: notificationAddConfirm
        },
        {
          path: '/Master/notification/edit',
          name: 'notificationEdit',
          component: notificationEdit
        },
        {
          path: '/Master/notification/editConfirm',
          name: 'notificationEditConfirm',
          component: notificationEditConfirm
        },
        {
          path: '/Master/maintenance',
          name: 'maintenance',
          component: maintenance
        },
        {
          path: '/Master/maintenance/detail',
          name: 'maintenanceDetail',
          component: maintenanceDetail
        },
        {
          path: '/Master/maintenance/add',
          name: 'maintenanceAdd',
          component: maintenanceAdd
        },
        {
          path: '/Master/maintenance/addConfirm',
          name: 'maintenanceAddConfirm',
          component: maintenanceAddConfirm
        },
        {
          path: '/Master/maintenance/edit',
          name: 'maintenanceEdit',
          component: maintenanceEdit
        },
        {
          path: '/Master/maintenance/editConfirm',
          name: 'maintenanceEditConfirm',
          component: maintenanceEditConfirm
        },
        {
          path: '/Master/forcedUpdate',
          name: 'forcedUpdate',
          component: forcedUpdate
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresMasterAuth)) {
    const reloadCheck = !systemAdminDefine.state.loginFlag
    if (!systemAdminDefine.state.loginFlag) {
      systemAdminDefine.mutations.restoreSession(systemAdminDefine.state)
    }
    if (reloadCheck) {
      if (systemAdminDefine.state.loginFlag) {
        switch (to.name) {
          case 'corporationDetail':
          case 'corporationEdit':
          case 'corporationAdd':
          case 'corporationLogExport':
          case 'corporationNotifications':
          case 'corporationMaintenance':
          case 'corporationUsageExport':
            next({
              path: '/master/corporations'
            })
            break
          case 'notificationDetail':
          case 'notificationAdd':
          case 'notificationAddConfirm':
          case 'notificationEdit':
          case 'notificationEditConfirm':
            next({
              path: '/master/notification'
            })
            break
          case 'maintenanceDetail':
          case 'maintenanceAdd':
          case 'maintenanceAddConfirm':
          case 'maintenanceEdit':
          case 'maintenanceEditConfirm':
            next({
              path: '/master/maintenance'
            })
            break
          case 'mailHistoryDetail':
            next({
              path: '/master/mailHistory'
            })
            break
          default:
            next()
        }
      } else {
        next({
          path: '/Master/Pages',
          query: {redirect: to.fullPath}
        })
      }
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    const reloadCheck = !masters.state.loginFlag
    if (!masters.state.loginFlag) {
      masters.mutations.restoreSession(masters.state)
    }
    // ログインされているかどうか認証。
    // もしされていないならば、ログインページにリダイレクトする。
    if (reloadCheck) {
      if (masters.state.loginFlag && !masters.state.browsingAccountFlg) {
        switch (to.name) {
          case 'deviceDetail':
          case 'deviceEdit':
          case 'deviceAdd':
            next({
              path: '/devices'
            })
            break
          case 'placeDetail':
          case 'placeEdit':
          case 'placeAdd':
            next({
              path: '/places'
            })
            break
          case 'belongDetail':
          case 'belongEdit':
          case 'belongAdd':
            next({
              path: '/belongs'
            })
            break
          case 'careworkerDetail':
          case 'careworkerEdit':
          case 'careworkerAdd':
            next({
              path: '/careworkers'
            })
            break
          case 'assessmentInfoDetail':
            next({
              path: '/assessmentInfos'
            })
            break
          case 'adminAccountDetail':
          case 'adminAccountEdit':
          case 'adminAccountAdd':
            next({
              path: '/adminAccounts'
            })
            break
          case 'auditLoggingDetail':
          case 'auditLoggingEdit':
            next({
              path: '/auditLoggings'
            })
            break
          case 'loginUserDetail':
            next({
              path: '/loginUsers'
            })
            break
          case 'assignDetail':
          case 'assignEdit':
          case 'assignAdd':
            next({
              path: '/assigns'
            })
            break
          case 'reserveDetail':
          case 'reserveEdit':
          case 'reserveAdd':
            next({
              path: '/reserve'
            })
            break
          default:
            next()
        }
      } else if (
        masters.state.loginFlag &&
        masters.state.browsingAccountFlg &&
        (to.name === 'adminAccounts' ||
          to.name === 'adminAccountDetail' ||
          to.name === 'adminAccountEdit' ||
          to.name === 'loginUsers' ||
          to.name === 'loginUserDetail' ||
          to.name === 'dashboard' ||
          to.name === 'notifications')
      ) {
        switch (to.name) {
          case 'adminAccountDetail':
          case 'adminAccountEdit':
            next({
              path: '/adminAccounts'
            })
            break
          case 'loginUserDetail':
            next({
              path: '/loginUsers'
            })
            break
          default:
            next()
        }
      } else {
        next({
          path: '/Pages',
          query: {redirect: to.fullPath}
        })
      }
    } else {
      next()
    }
  } else {
    next() // next() を常に呼び出すよう設定する。
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/CareRingsRouter.js